<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
       {{ currentLanguage }} <i class="fa fa-flag"></i> 
    </template>
    <template slot="dropdown">
        <b-dropdown-item v-for="(lang, i) in languages" :key="`Lang${i}`" :value="lang.key" @click="$i18n.locale = lang.code">{{ lang.name }}</b-dropdown-item>
    </template>
  </AppHeaderDropdown>

</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import { mapState } from 'vuex'


export default {
  name: 'LanguageDropdown',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
       
      }
  },
    computed: {
        currentLanguage: function () {
            var index =  this.languages.map((o) => o.code).indexOf(this.$i18n.locale);
            return this.languages[index].name;
        },
        ...mapState(['languages'])
    },


}
</script>



// WEBPACK FOOTER //
// src/components/LanguageDropdown.vue